import React from "react";
import { motion } from "framer-motion";

export function Reveal({ children, delay = 0, className = "" }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] }}
      className={className}
    >
      {children}
    </motion.div>
  );
}

export function SectionTitle({ eyebrow, title, subtitle, center = false }) {
  return (
    <div className={`mb-12 ${center ? "text-center mx-auto max-w-2xl" : "max-w-2xl"}`}>
      {eyebrow && <div className="text-coral font-semibold tracking-widest uppercase text-xs mb-3">{eyebrow}</div>}
      <h2 className="font-heading text-3xl sm:text-4xl font-bold text-navy tracking-tight">{title}</h2>
      {subtitle && <p className="mt-4 text-lg text-navy/60 leading-relaxed">{subtitle}</p>}
    </div>
  );
}

export function Stars({ n = 5 }) {
  return (
    <div className="flex gap-0.5 text-mustard">
      {Array.from({ length: n }).map((_, i) => <span key={i}>★</span>)}
    </div>
  );
}
